import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/pages/home/Home.vue";
import Login from "@/pages/Login.vue";
import Logout from "@/pages/Logout.vue";
import * as firebase from "firebase/app";
import "firebase/auth";
import Feed from "@/pages/Feed.vue";
import { isBetaTester } from "@/util/users";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Feed,
      meta: {
        isAuthRequired: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        isAuthRequired: false
      }
    },
    {
      path: "/beta-access",
      name: "beta-access",
      component: () =>
        import(/* webpackChunkName: "feed" */ "@/pages/BetaAccess.vue"),
      meta: {
        isAuthRequired: false
      }
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout,
      meta: {
        isAuthRequired: false
      }
    },
    {
      path: "/feed",
      name: "feed",
      component: () =>
        import(/* webpackChunkName: "feed" */ "@/pages/Feed.vue"),
      meta: {
        isAuthRequired: true
      }
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "@/pages/About.vue"),
      meta: {
        isAuthRequired: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;

  const isAuthRequired = to.matched.some(record => record.meta.isAuthRequired);

  if (!isAuthRequired) {
    next();
    return;
  }

  if (!currentUser || !currentUser.email) {
    next("login");
    return;
  }

  // User not in the whitelist
  if (!isBetaTester(currentUser.email)) {
    next("beta-access");
    return;
  }

  // User has access
  if (isBetaTester(currentUser.email)) {
    next();
    return;
  }

  // Fallback for any case we missed, user is redirected to login page
  next("login");
});
export default router;
